<template>
	<div>
		<div
			class="accordion__list__item__title"
			@click="toggled = !toggled"
			:class="{ toggled: toggled === true }"
		>
			<span
				class="title"
				v-if="title"
			>{{ title }}</span>
			<span
				class="title"
				v-else
			>Something went wrong...</span>

			<div class="accordion__list__item__text">
				<transition name="slide-fade">
					<span
						v-if="toggled === true"
						v-html="text"
					></span>
				</transition>
			</div>

			<span
				class="indicator"
				:class="{ closed: toggled === false }"
			>&times;</span>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			toggled: false,
			window: {
				width: 0,
				height: 0,
			},
		};
	},

	props: {
		title: {
			type: String,
		},
		text: {
			type: String,
		},
	},

	computed: {},

	watch: {},

	methods: {
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},
	},

	filters: {},

	components: {},

	created() {
		window.addEventListener('resize', this.handleResize);
	},
	destroyed() {
		window.removeEventListener('resize', this.handleResize);
	},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.accordion__list__item {
	&__title {
		background: white;
		padding: 1.5rem 0 0;
		display: grid;
		grid-template-columns: 200px 1fr 50px;
		column-gap: 2rem;
		justify-content: space-between;
		align-items: flex-start;
		transition: 0.2s ease all;
		border-top: 2px solid #f4f4f4;
		position: relative;

		@media (max-width: $md) {
			grid-template-columns: 1fr 1fr 50px;
		}

		&:hover {
			cursor: pointer;
			transition: 0.2s ease all;
		}

		@media (max-width: $md) {
			padding: 1rem 0 0;
		}

		span {
			&.title {
				line-height: auto;
				font-size: 2rem;
				font-weight: bold;
				color: $signs-teal;

				@media (max-width: $md) {
					grid-column: span 2;
					order: 1;
				}
			}

			&.indicator {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				font-weight: 400;
				color: $signs-pink;
				top: 10px;
				right: 10px;
				font-size: 3rem;
				width: 50px;
				height: 50px;
				border-radius: 50%;
				transform: rotate(0deg);
				transition: 0.2s ease all;

				@media (max-width: $md) {
					grid-column: span 1;
					order: 2;
					top: 0;
				}

				&.closed {
					transform: rotate(45deg);
					transition: 0.2s ease all;
				}
			}
		}
	}

	&__text {
		padding: 0 0 1rem;
		line-height: 1.5rem;
		color: $signs-teal;

		@media (max-width: $md) {
			padding: 0;
			grid-column: span 3;
			order: 3;

			span {
				display: flex;
				padding: 1rem 0;
				flex-direction: column;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/AccordionListItem.vue